var React = require('react');
var ReactRouter = require('react-router');
var Link = ReactRouter.Link;
var Shopify = require('./shopify');
var HeaderPage = require('./header-page');
var OpeningList = require('./collapsable-group');
var ScrollToTop = require('./scroll-to-top');

module.exports = React.createClass({

  mixins: [ ScrollToTop ],

  getInitialState: function() {
    return { openings: [] }
  },

  componentDidMount: function() {

    document.title = "Career @ Ingledew's Shoes";

    this.scrollToTop('career-page');

    Shopify.getBlog('career', this.blogGot);
    setTimeout(function() { jQuery(window).scroll(); }, 300);
  },

  blogGot: function(articles) {
    if (articles.length) {
      this.setState({ openings: <OpeningList name={"Current Openings"}
                                             items={articles}
                                             noFade={true}
                                             blogIndex={1} /> });
    } else {
      this.setState({ openings: <div className="empty-msg">
                                  <p>Thank you for your interest, at this time we don’t have any openings. But please check back from time to time as we will keep this page up to date as soon as postings become available.</p>
                                </div> });
    }
  },

  render: function(){
    return <div>
         <HeaderPage image={CMS.career.img} imageM={CMS.career.imgM}
                     prefix={CMS.career.prefix} title={CMS.career.title}
                     desc={CMS.career.desc}/>
         <main id="content" className="container" role="main">
            <div className="row">
                <div className="col-md-8 col-md-offset-2">
                {this.state.openings}
                </div>
            </div>
        </main>
      </div>
  }
});

